// 把数字变成 千分位
export const getLocaleString = (a) => {
  if (a) {
    let p = Number(a);
    let m = parseFloat(a).toFixed(0);
    let q = Number(m);
    return q.toLocaleString();
  }
};
export const isPhone = (value) => {
  return /^1[3-9]\d{9}$/.test(value);
};

export const isEmail = (value) => {
  return /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value);
};

// 格式化邮箱显示
export const formatEmail = (email) => {
  if (!email) return "";

  // 分割邮箱地址
  const [localPart, domainPart] = email.split("@");

  if (!domainPart) {
    return email; // 不是有效的邮箱格式
  }

  let maskedLocalPart = "";
  if (localPart.length <= 3) {
    // 如果本地部分（@前）少于等于3个字符，全部显示
    maskedLocalPart = localPart;
  } else {
    // 保留前3个字符，其余用*代替
    maskedLocalPart =
      localPart.substring(0, 3) + "*".repeat(localPart.length - 3);
  }

  return `${maskedLocalPart}@${domainPart}`;
};

// 复制文本
/**
 *
 * @param {*} value // 复制文字的值
 * @param {*} successCallback 复制成功的提示函数
 */
export const copyText = (value, successCallback) => {
  if (window.isSecureContext) {
    navigator.clipboard.writeText(value).then(() => {
      successCallback && successCallback();
    });
  }
  //不安全域使用
  else {
    const textArea = document.createElement("textarea");
    document.body.appendChild(textArea);
    textArea.textContent = value;
    //选择
    textArea.select();
    //复制
    document.execCommand && document.execCommand("copy");
    // document.body.removeChild(textArea);
    successCallback && successCallback();
  }
};

// 在 tools.js 中添加辅助函数
export const toUrlSafeBase64 = (base64String) => {
  return base64String
    .replace(/\+/g, "-") // 将 + 替换为 -
    .replace(/\//g, "_") // 将 / 替换为 _
    .replace(/=/g, ""); // 移除填充符 =
};

export const fromUrlSafeBase64 = (urlSafeString) => {
  // 恢复为标准Base64格式
  let standardBase64 = urlSafeString.replace(/-/g, "+").replace(/_/g, "/");

  // 添加必要的填充
  while (standardBase64.length % 4 !== 0) {
    standardBase64 += "=";
  }

  return standardBase64;
};
